const getAll = () => {
  const importAll = import.meta.glob('./*.json', { eager: true })
  return Object.entries(importAll).map(([, module]) => module.default)
}

export default getAll()
